import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectFunctionsEmulator, getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCoODNfDEDcXK6Vi-bxGf3rQjyXgUEWYo0",
  authDomain: "familyaichat-1998.firebaseapp.com",
  projectId: "familyaichat-1998",
  storageBucket: "familyaichat-1998.firebasestorage.app",
  messagingSenderId: "270276432354",
  appId: "1:270276432354:web:b72e3610fa4d742bc0a9bb",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app);
export const storage = getStorage(app);

if (process.env.REACT_APP_USE_FIREBASE_EMULATOR === "true") {
  connectFunctionsEmulator(functions, "localhost", 5001);
  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "localhost", 8080);
}
